<template>
  <div
    class="modal fade"
    id="addSimpleScheduledEvent"
    tabindex="-1"
    aria-labelledby="addSimpleScheduledEventLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="addSimpleScheduledEventLabel">
            Add Event to Calendar
          </h5>
          <button
            type="button"
            class="btn-close"
            id="addSimpleScheduledEventClose"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <label
            class="form-label mt-3"
            for="form6Example1"
            style="margin-top: 5px"
            >Name<span class="text-danger">*</span></label
          >
          <input
            type="text"
            id="form6Example1"
            class="form-control v-step-2"
            placeholder="e.g. Junior High Basketball Tournament"
            v-model="newScheduledEvent.name"
            required
          />

          <label
            class="form-label mt-3"
            for="form6Example4"
            style="margin-top: 5px"
            >Location (Optional)
            <span
              v-if="addressVerified"
              class="text-muted"
              style="font-size: 12px"
              ><i class="fa-solid fa-circle-check"></i> Verified</span
            >
          </label>
          <vue-google-autocomplete
            ref="address"
            id="map"
            classname="form-control"
            placeholder="Address"
            class="card-input__input"
            :country="['us']"
            v-on:placechanged="getAddressData"
            v-on:change="setAddressData"
            v-model="newScheduledEvent.location"
          >
          </vue-google-autocomplete>

          <div class="row mt-3">
            <div class="col-md-7 col-sm-3">
              <label class="form-label"
                >Description<span class="text-danger">*</span></label
              >
            </div>
          </div>

          <textarea
            class="form-control v-step-4"
            rows="4"
            placeholder="e.g. The Junior High Basketball Tournament will...."
            v-model="newScheduledEvent.description"
            required
            style="min-height: 150px"
          ></textarea>

          <div class="mt-3">
            <label class="form-label">Memberships (Optional)</label>
            <multiselect
              v-model="selectedMemberships"
              :options="memberships"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Select memberships"
              label="membershipName"
              track-by="_id"
              :preselect-first="false"
            >
              <template #selection="{ values, isOpen }">
                <span
                  class="multiselect__single"
                  v-if="values.length && !isOpen"
                >
                  {{ values.length }} memberships selected
                </span>
              </template>
            </multiselect>
          </div>

          <div
            class="mt-3"
            style="
              border: 3px solid #45487a;
              border-radius: 15px;
              max-width: 558px;
            "
          >
            <div class="m-3">
              <div class="row">
                <div class="col-md-5">
                  <label class="form-label"
                    >Starting Day: <strong>{{ getEventDate }}</strong></label
                  >
                </div>
                <div class="col-md-5">
                  <div class="form-check d-flex mb-4">
                    <input
                      class="form-check-input me-2"
                      type="checkbox"
                      value=""
                      v-model="allDayEvent"
                    />
                    <label class="form-check-label"> All Day Event?</label>
                  </div>
                </div>
              </div>

              <div class="row" v-if="!allDayEvent">
                <div class="col" style="margin-top: 5px">
                  <label class="form-label" for="form6Example3"
                    >Start Time</label
                  >
                  <input
                    v-model="newScheduledEvent.schedule.startTime"
                    required
                    id="form6Example1"
                    class="form-control mb-3"
                    type="time"
                  />
                </div>
                <div class="col" style="margin-top: 5px">
                  <label class="form-label" for="form6Example3">End Time</label>
                  <input
                    v-model="newScheduledEvent.schedule.endTime"
                    required
                    id="form6Example1"
                    class="form-control mb-3"
                    type="time"
                  />
                </div>
              </div>

              <div class="form-check d-flex mb-4" style="margin-top: 20px">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  value=""
                  v-model="newScheduledEvent.schedule.repeating"
                />
                <label class="form-check-label v-step-8">
                  This Event is Recurring?</label
                >
              </div>
              <div v-if="newScheduledEvent.schedule.repeating">
                <ul class="list-group">
                  <li class="list-group-item">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      value="DAY"
                      v-model="newScheduledEvent.schedule.repeatingSetting"
                    />
                    Every Day
                  </li>
                  <li class="list-group-item">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      value="WEEK"
                      checked
                      v-model="newScheduledEvent.schedule.repeatingSetting"
                    />
                    Every Week
                  </li>
                  <li class="list-group-item">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      value="MONTH"
                      checked
                      v-model="newScheduledEvent.schedule.repeatingSetting"
                    />
                    Every Month
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="createScheduledEvent()"
          >
            Schedule Event
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import axios from 'axios'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    VueGoogleAutocomplete,
    Multiselect,
  },
  data() {
    return {
      addressVerified: false,
      allDayEvent: false,
      memberships: [],
      selectedMemberships: [],
      newScheduledEvent: {
        name: '',
        description: '',
        location: '',
        date: {},
        schedule: {
          startTime: '',
          endTime: '',
          repeating: false,
          repeatingSetting: '',
          date: '',
        },
      },
    }
  },
  props: {
    eventDate: String,
    calendarID: String,
  },
  methods: {
    getAddressData(addressData, placeResultData, id) {
      console.log(placeResultData)
      console.log(id)
      console.log(addressData)
      this.newScheduledEvent.location = placeResultData.formatted_address
      this.addressVerified = true
    },
    setAddressData(e) {
      if (!this.newScheduledEvent.location) {
        console.log(e)
        this.newScheduledEvent.location = e.toString()
      }
    },
    async fetchMemberships() {
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        const response = await axios.get(
          import.meta.env.VITE_APP_DB_URL +
            'membership/getCoachMemberships?id=' +
            user._id,
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('jwt'),
            },
          }
        )
        console.log(response.data)
        this.memberships = response.data
      } catch (error) {
        console.error('Error fetching memberships:', error)
      }
    },
    async createScheduledEvent() {
      if (this.detailsComplete() == 1) {
        return
      }
      swal({
        title: 'Confirm Details',
        text: 'Are you sure you would like to schedule this event?',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(willCreate => {
        if (willCreate) {
          let url =
            import.meta.env.VITE_APP_DB_URL +
            'scheduling/createSimpleScheduledEvent'

          if (this.allDayEvent) {
            this.newScheduledEvent.schedule.startTime = '00:00'
            this.newScheduledEvent.schedule.endTime = '23:59'
          }

          this.newScheduledEvent.schedule.date = new Date(
            this.eventDate
          ).toISOString()

          // Add selected membership IDs to the event
          this.newScheduledEvent.membershipIds = this.selectedMemberships.map(
            membership => membership._id
          )

          axios
            .post(
              url,
              {
                newScheduledEvent: this.newScheduledEvent,
                calendarID: this.calendarID,
              },
              {
                headers: {
                  Authorization: 'Bearer ' + localStorage.getItem('jwt'),
                },
              }
            )
            .then(response => {
              swal('Success', 'New Event Scheduled!', 'success')
              document.getElementById('addSimpleScheduledEventClose').click()
              this.$emit('eventCreated', response.data.simpleScheduledEvent)
            })
            .catch(function (err) {
              let error = err.response
              swal('Error', error.data.errorMessage, 'error')
            })
        }
      })
    },

    detailsComplete() {
      if (!this.newScheduledEvent.name) {
        swal('Error', 'Name must be filled out.', 'error')
        return 1
      }
      if (!this.newScheduledEvent.description) {
        swal('Error', 'Description must be filled out.', 'error')
        return 1
      }

      if (
        !this.allDayEvent &&
        (!this.newScheduledEvent.schedule.startTime ||
          !this.newScheduledEvent.schedule.endTime)
      ) {
        swal(
          'Error',
          'Start and end times must be filled out if NOT an all day event.',
          'error'
        )
        return 1
      }
      return 0
    },
  },
  computed: {
    getEventDate() {
      return new Date(this.eventDate).toLocaleDateString()
    },
  },
  created() {
    if (this.eventDate) {
      this.newScheduledEvent.schedule.date = new Date(
        this.eventDate
      ).toISOString()
    }
    this.fetchMemberships()
  },
}
</script>

<style scoped>
.btn-primary {
  background-color: #19d412 !important;
  border-color: #19d412 !important;
}
.form-check-input:checked {
  background-color: #19d412 !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(25, 212, 18, 0.6) !important;
}
.form-check-input:hover .form-check-input:active,
.form-check-input:focus {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(25, 212, 18, 0.6) !important;
}
.btn-primary:hover,
.btn-primary:active,
.btn-primary:visited .btn-primary:focus,
.btn-primary:active,
.btn-primary.active .input-color,
.body-color .input-border-color {
  background-color: #19d412 !important;
  border-color: #19d412 !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(25, 212, 18, 0.6) !important;
}
.form-control:-webkit-autofill,
.form-control:-webkit-autofill:hover,
.form-control:-webkit-autofill:focus {
  border-color: #19d412 !important;
  box-shadow: 0 0 0 1000px rgb(255, 255, 255) inset !important;
  background-color: #ffffff !important;
}
.form-control:focus,
.form-control:visited,
.form-control:active,
.form-control:hover,
.form-control:checked {
  border-color: #19d412 !important;
  background-color: #ffffff !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(25, 212, 18, 0.6) !important;
}

/* Add multiselect styles */
@import 'vue-multiselect/dist/vue-multiselect.css';

.multiselect {
  margin-bottom: 1rem;
}

.multiselect__tags {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  min-height: 38px;
}

.multiselect__tag {
  background: #19d412;
}

.multiselect__tag-icon:after {
  color: white;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #15b80f;
}

.multiselect__option--highlight {
  background: #19d412;
}

.multiselect__option--highlight:after {
  background: #19d412;
}

.multiselect__option--selected {
  background: #15b80f;
  color: white;
}

.multiselect__option--selected:after {
  background: #15b80f;
}
</style> 